export default __webpack_public_path__ + "static/media/suv_dark.62245c0c.png";